"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditTrailHeader = void 0;
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const select_1 = require("client/components/material/select");
const text_field_1 = require("client/components/material/text-field");
const modal_1 = require("client/components/modal");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/inventory-order/store");
const store_2 = require("client/modules/reporting/store");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const store_4 = require("client/modules/users/modules/users-list/store");
const store_5 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const React = require("react");
const react_1 = require("react");
const throttle_debounce_1 = require("throttle-debounce");
require("./audit-trail-header.less");
const switch_1 = require("client/components/material/switch/switch");
let AuditTrailHeader = class AuditTrailHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.sortUsersByname = (data) => {
            let sortedData = data.sort((a, b) => {
                const nameA = `${a.prefix} ${a.firstName} ${a.lastName} ${a.suffix}`.toLowerCase();
                const nameB = `${b.prefix} ${b.firstName} ${b.lastName} ${b.suffix}`.toLowerCase();
                return nameA.localeCompare(nameB);
            });
            return sortedData;
        };
        this.filterText = "";
        this.filterDate = "";
        this.siteId = 0;
        this.purchaseOrderId = "";
        this.startDate = "";
        this.endDate = "";
        this.userId = 0;
        this.patientId = 0;
        this.patientModal = false;
        this.rxId = "";
        this.claimId = "";
        // E-055
        this.eventAction = "";
        // E-055
        this.eventType = "";
        // E-055
        this.categoryReference = "";
        this.searchType = "eventAction"; //E-055.5
        this.showPatients = false;
        //C-055.31
        this.selectDate = true;
        this.loadPurchaseOrders = throttle_debounce_1.debounce(200, async (tmpSearch = false) => {
            await store_1.inventoryOrderStore.loadPurchaseOrders({
                count: 100,
                // order: this.order,
                search: this.filterText,
                // sort: this.orderBy,
                siteId: null,
                start: 0
            });
        });
        // C-123
        this.handleShowDisabledSitesToggle = async () => {
            this.showDisabledSites = !this.showDisabledSites;
            if (this.showDisabledSites) {
                await store_3.sitesListStore.loadDeletedSites();
            }
            else {
                await store_3.sitesListStore.loadSitesNoRelation();
            }
        };
        this.headerToggle = () => {
            store_2.reportsStore.editModal = !store_2.reportsStore.editModal;
        };
        this.handleLoader = () => {
            store_2.reportsStore.showLoader = !store_2.reportsStore.showLoader;
        };
        this.handleChangeSearchType = (searchType) => {
            //C-055.31
            if (searchType) {
            }
            this.selectDate = true;
            this.searchType = searchType;
            this.userId = 0;
            this.rxId = "";
            this.siteId = 0;
            this.patientId = 0;
        };
        this.handleChangeSite = (id) => {
            this.siteId = Number(id);
        };
        this.handlePurchaseOrderChange = (event, value) => {
            this.purchaseOrderId = value;
        };
        this.handleChangeUser = (id) => {
            this.userId = Number(id);
        };
        // E-055.3
        this.handleChangeCategory = (eventType) => {
            this.eventType = String(eventType);
        };
        this.handleSubmitQuery = async () => {
            this.handleLoader();
            this.headerToggle();
            await store_2.reportsStore.loadUserAuditTrail(this.searchType, this.userId, this.rxId, this.siteId, this.patientId, this.purchaseOrderId, this.startDate, this.endDate, this.claimId, this.eventAction, //E-055
            this.eventType, //E-055
            this.categoryReference, //E-055
            this.showDisabledSites, // C-123
            true);
        };
        this.handleRxIdChange = (e) => {
            const inputValue = e.target.value;
            this.rxId = inputValue;
        };
        this.handleClaimIdChange = (e) => {
            const inputValue = e.target.value;
            this.claimId = inputValue;
        };
        // E-055
        this.handleActionChange = (e) => {
            const inputValue = e.target.value;
            this.eventAction = inputValue;
        };
        // E-055
        this.handlecategoryReferenceChange = (e) => {
            const inputValue = e.target.value;
            this.categoryReference = inputValue;
        };
        // E-055
        this.handleEventChange = (e) => {
            const inputValue = e.target.value;
            this.eventType = inputValue;
        };
        this.handleClickTodayStart = () => {
            const date = new Date().toDateString();
            this.startDate = moment(date).format("YYYY-MM-DD");
        };
        this.handleClickTodayEnd = () => {
            const date = new Date().toDateString();
            this.endDate = moment(date).format("YYYY-MM-DD");
        };
        this.handleClickClearStart = () => {
            this.startDate = "";
        };
        this.handleClickClearEnd = () => {
            this.endDate = "";
        };
        this.handleDatePickerChangeStart = (value) => {
            this.startDate = moment(value).format("YYYY-MM-DD");
        };
        this.handleDatePickerChangeEnd = (value) => {
            this.endDate = moment(value).format("YYYY-MM-DD");
        };
        this.handleCancel = () => {
            store_2.reportsStore.editModal = !store_2.reportsStore.editModal;
        };
        //C-055.31
        this.selectDateOnChange = () => {
            this.selectDate = !this.selectDate;
        };
    }
    get availableUsers() {
        const isAdmin = store_5.usersStore.user.value.groupId == 1 || store_5.usersStore.user.value.groupId == 4;
        const currentUser = store_5.usersStore.user.value;
        const isDistributor = store_5.usersStore.user.value.distUser;
        const isClinicRoles = store_5.usersStore.user.value.siteUser || store_5.usersStore.user.value.groupId === 9;
        let matchUserPharmacy = [];
        if (isDistributor) {
            store_4.usersListStore.users.value.filter((item) => {
                if (item.distUser) {
                    matchUserPharmacy.push(item);
                }
            });
            let sortedData = this.sortUsersByname(matchUserPharmacy);
            return sortedData.map((user, i) => ({
                id: i,
                label: `${user.prefix} ${user.firstName} ${user.lastName} ${user.suffix}`,
                value: user.id.toString()
            }));
        }
        else if (isClinicRoles) {
            store_4.usersListStore.users.value.filter(site => {
                const userGroupId = store_5.usersStore.user.value.groupId;
                switch (userGroupId) {
                    case 7:
                        if (site.groupId === 7)
                            matchUserPharmacy.push(site);
                        break;
                    case 9:
                        if (site.groupId === 9)
                            matchUserPharmacy.push(site);
                        break;
                    case 6:
                        if (site.groupId !== 5 && (site.groupId === 6 || site.groupId === 9 || site.groupId === 7)) {
                            matchUserPharmacy.push(site);
                        }
                        break;
                    default:
                        if (site.siteUser || site.groupId === 9)
                            matchUserPharmacy.push(site);
                        break;
                }
            });
            let sortedData = this.sortUsersByname(matchUserPharmacy);
            return sortedData.map((user, i) => ({
                id: i,
                label: `${user.prefix} ${user.firstName} ${user.lastName} ${user.suffix}`,
                value: user.id.toString()
            }));
            // }
        }
        else if (isAdmin) {
            // B-097.4 sorting Alphabetical
            const sortedUsers = store_4.usersListStore.users.value.sort((a, b) => {
                const nameA = `${a.prefix} ${a.firstName} ${a.lastName} ${a.suffix}`.toLowerCase();
                const nameB = `${b.prefix} ${b.firstName} ${b.lastName} ${b.suffix}`.toLowerCase();
                return nameA.localeCompare(nameB);
            });
            return sortedUsers.map((user, i) => ({
                id: i,
                label: `${user.prefix} ${user.firstName} ${user.lastName} ${user.suffix}`,
                value: user.id.toString()
            }));
        }
        else {
            const assgniedPharmcay = currentUser.sites.map((site) => site);
            for (let user of store_4.usersListStore.users.value) {
                for (let site of user.sites) {
                    if (assgniedPharmcay.includes(site.id)) {
                        matchUserPharmacy.push(user);
                    }
                }
            }
            // B-097.4 sorting Alphabetical
            let sortedData = this.sortUsersByname(matchUserPharmacy);
            const uniqueUserOfPharmacy = sortedData === null || sortedData === void 0 ? void 0 : sortedData.filter((obj, index, self) => index === self.findIndex((u) => u.id === obj.id));
            return uniqueUserOfPharmacy === null || uniqueUserOfPharmacy === void 0 ? void 0 : uniqueUserOfPharmacy.map((user, i) => ({
                id: i,
                label: `${user.prefix} ${user.firstName} ${user.lastName} ${user.suffix}`,
                value: user.id.toString()
            }));
        }
    }
    get availablePurchaseOrders() {
        return store_1.inventoryOrderStore.purchaseOrders
            ? store_1.inventoryOrderStore.purchaseOrders.map((po, i) => ({
                id: i,
                label: po.id,
                value: po.id.toString()
            }))
            : [];
    }
    // B-097.2 
    get availableSites() {
        const options = [];
        const checkRoles = store_5.usersStore.user.value.groupId == 1 || store_5.usersStore.user.value.groupId == 4;
        if (checkRoles) {
            if (store_3.sitesListStore.sites.value) {
                store_3.sitesListStore.sites.value.forEach((site, i) => {
                    options.push({
                        id: i,
                        label: site.displayName || site.name,
                        value: site.id.toString(),
                        live: site.live // C-123
                    });
                });
            }
        }
        else {
            const userSites = store_5.usersStore.user.value.sites;
            const filteredSites = store_3.sitesListStore.sites.value.filter((site, i) => userSites.includes(site.id));
            filteredSites.forEach((site, i) => {
                options.push({
                    id: i,
                    label: site.displayName || site.name,
                    value: site.id.toString(),
                    live: site.live // C-123
                });
            });
        }
        return options;
    }
    get availableSearchTypes() {
        return [
            {
                id: 1,
                label: "Action Type",
                value: "eventAction"
            },
            {
                id: 2,
                label: "Category Reference",
                value: "categoryReference"
            },
            {
                id: 3,
                label: "Category Search",
                value: "eventType"
            },
            {
                id: 4,
                label: "Claim ID",
                value: "claimId"
            },
            {
                id: 5,
                label: "Date Search",
                value: "date"
            },
            {
                id: 6,
                label: "Purchase Order #",
                value: "purchaseOrder"
            },
            {
                id: 7,
                label: "RX Number",
                value: "rxId"
            },
            {
                id: 8,
                label: "Site Search",
                value: "siteId"
            },
            {
                id: 9,
                label: "User Search",
                value: "user"
            },
        ];
    }
    componentWillMount() {
        this.userId = store_5.usersStore.user.value.id;
        store_3.sitesListStore.loadSitesNoRelation();
        this.handleChangeUser(String(this.userId));
        // B-111.1_PROD remove static value
        let options = {
            page: 1, limit: 500, showDisabled: true // B-111.1_PROD
        };
        store_4.usersListStore.loadUsers(options); // B-111.1_PROD
        this.loadPurchaseOrders();
    }
    render() {
        const { label = "Search", title, withDatePicker } = this.props;
        const buttons = [];
        buttons.push(React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"), React.createElement(button_1.MaterialButton, { className: "btnSubmit", onClick: this.handleSubmitQuery, primary: true, style: { marginLeft: "1em" } }, "Submit"));
        return (React.createElement("div", null,
            React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                title && (React.createElement("div", { className: "filter-bar__title", style: { margin: "10px" } },
                    React.createElement("div", { className: "filter-bar__title-text" }, title))),
                React.createElement(button_1.MaterialButton, { onClick: () => this.headerToggle(), style: { margin: "10px" } }, "Search Options")),
            store_2.reportsStore.editModal ? (React.createElement("div", { className: "audit-trail" },
                React.createElement(modal_1.Modal, { onCancel: this.headerToggle, height: "fit-content", top: "25%", width: "100%" // C-123
                    , overflowY: true, buttons: buttons },
                    React.createElement("div", { className: "filter-bar" },
                        React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', marginBottom: 10 } },
                            React.createElement(switch_1.MaterialSwitch, { label: "Show Disabled Sites", value: "showDisabledSites", checked: this.showDisabledSites, onChange: this.handleShowDisabledSitesToggle }),
                            this.searchType !== "date" &&
                                React.createElement(switch_1.MaterialSwitch, { label: "Include Date Range (Optional)", value: "reqPro", onChange: this.selectDateOnChange, checked: this.selectDate ? true : false })),
                        React.createElement("div", { className: "" },
                            React.createElement(select_1.MaterialSelect, { options: this.availableSearchTypes, required: true, label: "Search Type", onSelect: this.handleChangeSearchType, value: this.searchType, width: "100%" }),
                            React.createElement("br", null),
                            this.searchType === "user" ? (React.createElement(React.Fragment, null,
                                React.createElement(select_1.MaterialSelect, { options: this.availableUsers, required: true, searchable: true, label: "User", onSelect: this.handleChangeUser, value: String(this.userId) || "", width: "100%" }),
                                React.createElement("br", null))) : null,
                            this.searchType === "rxId" ||
                                this.searchType === "siteId" ? (React.createElement(React.Fragment, null,
                                React.createElement(select_1.MaterialSelect, { showDisabledSites: this.showDisabledSites, backgroundColor: true, options: this.availableSites, required: true, searchable: true, label: "Site", onSelect: this.handleChangeSite, value: String(this.siteId) || "", width: "100%" }),
                                React.createElement("br", null))) : null,
                            this.searchType === "purchaseOrder" ? (React.createElement(React.Fragment, null,
                                React.createElement(text_field_1.MaterialTextField, { className: "rx-search-field", required: true, label: "Purchase Order #", value: this.purchaseOrderId, onChange: this.handlePurchaseOrderChange, type: "number", numType: "integer" }),
                                React.createElement("br", null))) : null,
                            this.searchType === "rxId" ? (React.createElement(React.Fragment, null,
                                React.createElement(text_field_1.MaterialTextField, { className: "rx-search-field", required: true, label: "RX Number", value: this.rxId, onChange: e => this.handleRxIdChange(e) }),
                                React.createElement("br", null))) : null,
                            this.searchType === "claimId" ? (React.createElement(React.Fragment, null,
                                React.createElement(text_field_1.MaterialTextField, { className: "rx-search-field", required: true, label: "Claim ID", value: this.claimId, onChange: this.handleClaimIdChange }),
                                React.createElement("br", null))) : null,
                            this.searchType === "eventAction" ? (React.createElement(React.Fragment, null,
                                React.createElement(text_field_1.MaterialTextField, { className: "rx-search-field", required: true, label: "Action Type", value: this.eventAction, onChange: this.handleActionChange }),
                                React.createElement("br", null))) : null,
                            this.searchType === "categoryReference" ? (React.createElement(React.Fragment, null,
                                React.createElement(text_field_1.MaterialTextField, { className: "rx-search-field", required: true, label: "Category Reference", value: this.categoryReference, onChange: this.handlecategoryReferenceChange }),
                                React.createElement("br", null))) : null,
                            this.searchType === "eventType" ? (React.createElement(React.Fragment, null,
                                React.createElement(select_1.MaterialSelect, { options: this.availableCategory, required: true, searchable: true, label: "Category", onSelect: this.handleChangeCategory, value: String(this.eventType) || '', width: "100%" }),
                                React.createElement("br", null))) : null),
                        React.createElement("div", { style: { display: 'flex' } },
                            this.selectDate && withDatePicker && (React.createElement("div", { className: "filter-bar", style: { paddingRight: "1em" } },
                                React.createElement("h3", null, "Start Date: "),
                                React.createElement(date_picker_1.MaterialDatePicker, { className: "filter-bar__date-picker", label: "Start Date", required: true, value: this.startDate || "", onChange: this.handleDatePickerChangeStart }),
                                React.createElement("div", { style: { display: "flex", flexDirection: "row", marginTop: '1rem', placeContent: 'space-around' } },
                                    React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleClickTodayStart }, "Today"),
                                    React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClickClearStart }, "Clear")))),
                            this.selectDate && withDatePicker && (React.createElement("div", { className: "filter-bar" },
                                React.createElement("h3", null, "End Date: "),
                                React.createElement(date_picker_1.MaterialDatePicker, { className: "filter-bar__date-picker", label: "End Date", required: true, value: this.endDate || "", onChange: this.handleDatePickerChangeEnd }),
                                React.createElement("div", { style: { display: "flex", flexDirection: "row", marginTop: '1rem', placeContent: 'space-around' } },
                                    React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleClickTodayEnd }, "Today"),
                                    React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClickClearEnd }, "Clear"))))))))) : null,
            store_2.reportsStore.showLoader ? React.createElement(ui_1.UiLoadingIndicator, null) : null));
    }
    // E-055.3
    get availableCategory() {
        let arrObj = [
            { id: "1", label: 'All Category', value: "All" },
            { id: "2", label: 'Claim', value: "claim" },
            { id: "3", label: 'Claim Data', value: "claimData" },
            { id: "4", label: 'Distributor', value: "distributor" },
            { id: "5", label: 'EOB', value: "eob" },
            { id: "6", label: 'ERX', value: "erx" },
            { id: "7", label: 'General', value: "general" },
            { id: "8", label: 'Ledger', value: "ledger" },
            { id: "9", label: 'Order', value: "order" },
            { id: "10", label: 'Inventory', value: "inventory" },
            { id: "11", label: 'Inventory Site', value: "inventorySite" },
            { id: "12", label: 'Inventory Site Lot', value: "inventorySiteLot" },
            { id: "13", label: 'Purchase Order', value: "purchaseOrder" },
            { id: "14", label: 'Pad', value: "pad" },
            { id: "15", label: 'Patient', value: "patient" },
            { id: "16", label: 'Pharmacy', value: "pharmacy" },
            { id: "17", label: 'Provider', value: "provider" },
            { id: "18", label: 'Queue', value: "queue" },
            { id: "19", label: 'Schedule', value: "schedule" },
            { id: "20", label: 'User', value: "user" },
            { id: "21", label: 'Upload', value: "upload" },
            { id: "22", label: 'Connect Asset', value: "connectAsset" }
        ];
        // Sort the array in ascending order based on the label property
        arrObj.sort((a, b) => {
            if (a.label < b.label)
                return -1;
            if (a.label > b.label)
                return 1;
            return 0;
        });
        return arrObj;
    }
};
__decorate([
    mobx_1.computed
], AuditTrailHeader.prototype, "availableUsers", null);
__decorate([
    mobx_1.computed
], AuditTrailHeader.prototype, "availablePurchaseOrders", null);
__decorate([
    mobx_1.computed
], AuditTrailHeader.prototype, "availableSites", null);
__decorate([
    mobx_1.computed
], AuditTrailHeader.prototype, "availableSearchTypes", null);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "filterDate", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "purchaseOrderId", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "startDate", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "endDate", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "claimStatus", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "userId", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "patientId", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "patientModal", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "rxId", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "claimId", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "eventAction", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "eventType", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "categoryReference", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "searchType", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "showPatients", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "showDisabledSites", void 0);
__decorate([
    mobx_1.observable
], AuditTrailHeader.prototype, "selectDate", void 0);
AuditTrailHeader = __decorate([
    mobx_react_1.observer
], AuditTrailHeader);
exports.AuditTrailHeader = AuditTrailHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/audit-trail/components/audit-trail-header/audit-trail-header.tsx
// module id = 3874
// module chunks = 0